module.exports = __webpack_public_path__ + "img/NewDragCartIcon.8f71b03c.svg";